import React from 'react'
import { Route, Switch } from 'react-router'
import { MoContainer } from '../../Mo7/mo7UI'
import EditAnnouncement from './EditAnnouncement'
import DashHome from './DashHome'
import Sidebar from './Sidebar'
import Announcements from './Announcements'
import Messages from './Messages'
import Notifications from './Notifications'
export default function Dashboard() {
    return (
        <MoContainer flow="hidden" h="100vh" scroller>
            {/* Sidebar */}
            <Sidebar />

            {/* pages */}
            <MoContainer pd={{ l: "5rem",t:"0.5rem" }} h="100% " flow_x="hidden" flow_y="scroll" scroller>
                <Switch>
                    <Route exact path="/dashboard/home" component={DashHome} />
                    <Route exact path="/dashboard/edit-announcement/:announcement_id" component={EditAnnouncement} />
                    <Route exact path="/dashboard/announcements" component={Announcements} />
                    <Route exact path="/dashboard/notifications" component={Notifications} />
                    <Route exact path="/dashboard/messages" component={Messages} />
                </Switch>
            </MoContainer>
        </MoContainer >
    )
}

